import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function MessageBubble({ variant, className, ...rest }) {
    return (_jsx("div", { className: cn("fwfa-message", `fwfa-message--${variant}`, className), ...rest }));
}
//# sourceMappingURL=MessageBubble.js.map